var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Layout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.068 3.228a18.766 18.766 0 0 0-4.136 0 1.916 1.916 0 0 0-1.69 1.673 18.067 18.067 0 0 0 0 4.198 1.916 1.916 0 0 0 1.69 1.673c1.363.152 2.773.152 4.136 0a1.916 1.916 0 0 0 1.69-1.673 18.066 18.066 0 0 0 0-4.198 1.916 1.916 0 0 0-1.69-1.673z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.068 13.228a18.765 18.765 0 0 0-4.136 0 1.916 1.916 0 0 0-1.69 1.673 18.067 18.067 0 0 0 0 4.198 1.916 1.916 0 0 0 1.69 1.673c1.363.152 2.773.152 4.136 0a1.916 1.916 0 0 0 1.69-1.673 18.066 18.066 0 0 0 0-4.198 1.916 1.916 0 0 0-1.69-1.673z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.068 3.228a18.766 18.766 0 0 0-4.136 0 1.916 1.916 0 0 0-1.69 1.673 18.066 18.066 0 0 0 0 4.198 1.916 1.916 0 0 0 1.69 1.673c1.364.152 2.772.152 4.136 0a1.916 1.916 0 0 0 1.69-1.673 18.066 18.066 0 0 0 0-4.198 1.916 1.916 0 0 0-1.69-1.673z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.068 13.228a18.765 18.765 0 0 0-4.136 0 1.916 1.916 0 0 0-1.69 1.673 18.066 18.066 0 0 0 0 4.198 1.916 1.916 0 0 0 1.69 1.673c1.364.152 2.772.152 4.136 0a1.916 1.916 0 0 0 1.69-1.673 18.066 18.066 0 0 0 0-4.198 1.916 1.916 0 0 0-1.69-1.673z",
    fill: "#212121"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/Layout.3e8f8d3084d9914a9bc244c1ada7c973.svg";
export { ForwardRef as ReactComponent };